/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Ledgerservice2Inputs */

const zh_adminsubs_ledgerservice2 = /** @type {(inputs: Adminsubs_Ledgerservice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务`)
};

const en_adminsubs_ledgerservice2 = /** @type {(inputs: Adminsubs_Ledgerservice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service`)
};

const es_adminsubs_ledgerservice2 = /** @type {(inputs: Adminsubs_Ledgerservice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servicio`)
};

/**
* | output |
* | --- |
* | "Service" |
*
* @param {Adminsubs_Ledgerservice2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_ledgerservice2 = /** @type {((inputs?: Adminsubs_Ledgerservice2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Ledgerservice2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_ledgerservice2(inputs)
	if (locale === "en") return en_adminsubs_ledgerservice2(inputs)
	return es_adminsubs_ledgerservice2(inputs)
});
export { adminsubs_ledgerservice2 as "adminSubs_ledgerService" }